module.exports = new Promise(async (resolve, reject) => {
  try {
    const module = await import('https://sn2-whiteboard-dev3.web.app/assets/remoteEntry.js?t=1790758490415');
    resolve(module);
  } catch (error) {
    // console.error('Failed to load remote:', error);
    resolve(null);
  }
})
;